<template>
  <div class="mt-6 bg-white rounded-lg p-6">
    <h3 class="text-xl mb-6 font-semibold">Pagrindinė informacija</h3>
    <div class="join join-vertical w-full">
      <div class="collapse collapse-arrow join-item border-base-300 border">
        <input type="radio" name="support-accordion-4" />
        <div class="collapse-title text-lg">Prisijungimas prie sistemos</div>
        <div class="collapse-content">
          <p>
            Detali informacija apie prisijungimą prie sistemos pateikiama
            <a
              target="_blank"
              class="text-sky-800"
              href="https://drive.google.com/file/d/1XOAA0xYJCxj3RN3BRSjRPknAKzGTcOnq/view?usp=sharing"
              >instrukcijoje (pdf)</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- 
  <div class="mt-6 bg-white rounded-lg p-6 mb-4">
    <h3 class="text-xl mb-6 font-semibold">Dažniausiai užduodami klausimai</h3>
    <div class="join join-vertical w-full">
      <div class="collapse collapse-arrow join-item border-base-300 border">
        <input type="radio" name="support-accordion-4" />
        <div class="collapse-title text-lg">Kaip sukurti pavežėjimą?</div>
        <div class="collapse-content">
          <p class="pt-4 pb-2">
            Naujo pavežėjimo kūrimas, kai pasirinktai dienai nėra planuojamų
            kelionių:
          </p>
          <div class="video-container">
            <iframe
              src="https://drive.google.com/file/d/1KyP6Wmi6OxLY46zzYqY36E4G8PlR3dis/preview"
              width="100%"
              height="100%"
              allow="autoplay"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <div class="collapse collapse-arrow join-item border-base-300 border">
        <input type="radio" name="support-accordion-4" />
        <div class="collapse-title text-lg">
          Kaip įtraukti pavežėjimą į esamą kelionę?
        </div>
        <div class="collapse-content">
          <p class="pt-4 pb-2">
            Naujo pavežėjimo kūrimas ir įtraukimas į pasirinktoje dienoje
            suplanuotą kelionių:
          </p>
          <div class="video-container">
            <iframe
              src="https://drive.google.com/file/d/15IJZk84Dtxrv2spAjyR5U1r_vWIfgoOE/preview"
              width="100%"
              height="100%"
              allow="autoplay"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio (divide 9 by 16 = 0.5625) */
  height: 0;
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
